//Actions
import {
  SET_SENDER_PROFILES_DATA,
  SET_SENDER_PROFILES_LOADER,
  LOGOUT,
} from '../actions/action-types';

const initialState = {
  senderProfiles: [],
  rowsCount: 0,
  to: null,
  from: null,
  lastPage: null,
  currentPage: null,
  perPage: 20,
  totalSenderProfilesInDB: null,
  loading: false,
};

const senderProfilesReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SENDER_PROFILES_DATA:
      return {
        ...state,
        senderProfiles: payload.rows,
        rowsCount: payload.count,
        totalSenderProfilesInDB: payload.totalRecordsInDB,
        to: payload.to,
        from: payload.from,
        lastPage: payload.lastPage,
        currentPage: payload.currentPage,
        perPage: payload.perPage,
      };
    case SET_SENDER_PROFILES_LOADER:
      return { ...state, loading: payload };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export { senderProfilesReducers };

